import cookie from '../../utils/Tools/index'
import { deepCopy } from '../../utils/Tools/assist'
const spaceName = 'org'
export default {
  data () {
    return {
      [`${spaceName}LoadingMode`]: 0, // orgLoadingMode 0:没有全屏Loading，1:全屏Loading
      [`${spaceName}Loading`]: false, // orgLoading
      [`${spaceName}SelectedProjectId`]: '', // orgSelectedProjectId
      [`${spaceName}tree`]: [], // orgtree
      [`${spaceName}ExpandKeys`]: [], // orgExpandKeys
      [`${spaceName}Props`]: { // orgProps
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      },
      [`${spaceName}Lazy`]: true, // orgLazy
      [`${spaceName}EnclosureList`]: [], // orgEnclosureList
      [`${spaceName}Ladder`]: false, // orgLadder
      [`${spaceName}onlyRoom`]: false, // orgonlyRoom
      [`${spaceName}showProject`]: true, // orgshowProject
      sourceType: '',
      shouldBuildSearchIndex: false,
      treeRefName: ''
    }
  },
  methods: {
    [`${spaceName}getTreeData`] (id) { // orggetTreeData
    },
    [`${spaceName}initExpand`] () { // orggetinitExpand
      this[`${spaceName}tree`].map(a => {
        this[`${spaceName}ExpandKeys`].push(a.id)
      })
    },
    [`${spaceName}SetTreeDataToStore`] () {
      this.$store.commit('setTreeListData', this[`${spaceName}tree`])
    },
    async isChildren (node) {
      if (node.spatialCode >= 200000000 && node.spatialCode < 300000000) {
        let url = `SpaceOrg/getNextEnclosureByProject?projectId=${node.id}`
        let res = await this.$https.axios({ method: 'get', url, loading: this[`${spaceName}LoadingMode`] })
        return res.code === 'RESP0000' && res.data.enclosure.length === 0
      } else if (node.spatialCode >= 300000000) {
        // resolve(this[`${spaceName}findNode`](this[`${spaceName}EnclosureList`], node.data.id).children)
        let url = `SpaceOrg/getNextEnclosureByEnclosureId?enclosureId=${node.id}`
        let res = await this.$https.axios({ method: 'get', url, loading: this[`${spaceName}LoadingMode`] })
        return res.code === 'RESP0000' && res.data.enclosure.length === 0
      } else {
        // sonar规则校验语法必须else
      }
    },
    findTree (arr, id) {
      const defaultArr = arr || this[`${spaceName}tree`]
      var obj = ''
      defaultArr.forEach(o => {
        if (o.id === id) {
          obj = o
        }
        if (Array.isArray(o.downdistrict) && o.downdistrict.length > 0 && !obj) {
          obj = this.findTree(o.downdistrict, id)
        }
      })
      return obj
    },
    [`${spaceName}findNode`] (arry, id) {
      let children = null
      arry.forEach(o => {
        if (o.id === id) {
          children = o
        } else if (!children) {
          children = this[`${spaceName}findNode`](o.children, id)
        } else {
          // sonar规则校验语法必须else
        }
      })
      return children
    },
    [`${spaceName}formatTreeData`] (arry) {
      arry.forEach(o => {
        o.children = []
        o.disabled = true
        if (!this[`${spaceName}onlyRoom`] && 'util' in o) {
          o.disabled = false
        }
        if (this[`${spaceName}onlyRoom`] && (o.subLevel === '' || o.subLevel === null)) {
          o.disabled = false
        }
        if (o.subLevel === '' || o.subLevel === null) {
          o.leaf = true
        }
        if (Array.isArray(o.downdistrict) && o.downdistrict.length > 0) {
          o.children = o.children.concat(this[`${spaceName}formatTreeData`](o.downdistrict))
          delete o.downdistrict
        }
        if (Array.isArray(o.downproject) && o.downproject.length > 0) {
          o.children = o.children.concat(this[`${spaceName}formatTreeData`](o.downproject))
          delete o.downproject
        }
        if (Array.isArray(o.enclosureList) && o.enclosureList.length > 0) {
          o.children = o.children.concat(this[`${spaceName}formatTreeData`](o.enclosureList))
          delete o.enclosureList
        }
      })
      return arry
    },
    /**
     * 查找唯一管辖项目，非唯一返回null
     * @param list Array,
     * @param keys Array, 需要展开的条目ID，这是一个outer引用参数
     * @returns Object or null
     */
    [`findUnique${spaceName}`] (list, keys, filterId) { // findUniqueorg
      if (list) {
        let item = list[0]
        if (filterId) {
          item = list.filter(o => o.id === filterId)[0]
          if (!item) {
            list.forEach((d) => {
              item = this.findUniqueorg(d.children, keys, filterId) || item
            })
          }
          return item
        }
        if (item && item.spatialCode >= 200000000) {
          keys.push(item.id)
          return item
        } else if (item && item.children && item.children.length === 1) {
          keys.push(item.id)
          return this.findUniqueorg(item.children, keys, filterId)
        } else {
          // sonar规则校验语法必须else
        }
      }
      return null
    },
    buildSearchIndex (list) {
      const expandList = function (_list, keys = []) {
        for (const a of _list) {
          if (a.spatialCode < 200000000) {
            keys.push(a.id)
            if (a.children && a.children.length) {
              expandList(a.children, keys)
            }
          }
        }
      }
      expandList(list, this[`${spaceName}ExpandKeys`])

      this.$nextTick(() => {
        // 除第一节点外，其余全部节点收起
        const allNodes = this.$refs[this.treeRefName].$refs.treeEl.store._getAllNodes()
        for (let i = 0; i < allNodes.length; i++) {
          allNodes[i].expanded = false
        }
        allNodes[0].expanded = true
      })
    },
    [`${spaceName}loadNode`] (node, resolve) {
      if (!this.disabled) {
        if (this[`${spaceName}tree`].length === 0 && this[`${spaceName}showProject`]) {
          let userId = cookie.getCookie('UserId') // 获取userId
          // let url = `SpaceOrg/getCityAndProject?userId=${userId}`
          this[`${spaceName}Loading`] = true
          // this.$store.dispatch('GetCityProjectEnclosureData', { userId: userId, loading: this[`${spaceName}LoadingMode`] })
          this.$store.dispatch('GetCityProjectAllData', { userId: userId, loading: this[`${spaceName}LoadingMode`] }).then(resA => {
            const res = deepCopy(resA)
            this[`${spaceName}Loading`] = false
            this[`${spaceName}tree`] = this[`${spaceName}formatTreeData`]([res])
            var defaultValue = this.findUniqueorg(this[`${spaceName}tree`], [], this[`${spaceName}SelectedProjectId`] || null)
            if (node.level === 0) {
              this.sourceType = defaultValue && defaultValue.sourceType
              resolve(defaultValue ? [defaultValue] : this[`${spaceName}tree`])
              if (this.shouldBuildSearchIndex) {
                this.buildSearchIndex(this[`${spaceName}tree`])
              } else {
                this[`${spaceName}ExpandKeys`] = [this[`${spaceName}tree`].id]
              }
            } else {
              resolve(this[`${spaceName}findNode`](this[`${spaceName}tree`], node.data.id).children)
            }
          }).catch(e => {
            this[`${spaceName}Loading`] = false
          })
        } else {
          if (node.level === 0 && !this[`${spaceName}SelectedProjectId`]) {
            this[`${spaceName}ExpandKeys`] = [this[`${spaceName}tree`].id]
            return resolve(this[`${spaceName}tree`])
          } else if (((node.level === 0 && this[`${spaceName}SelectedProjectId`]) || (node.data.spatialCode >= 200000000 && node.data.spatialCode < 300000000))) {
            let id = this[`${spaceName}SelectedProjectId`] || node.data.id
            let url = `SpaceOrg/getNextEnclosureByProject?projectId=${id}`
            this.$https.axios({ method: 'get', url, loading: this[`${spaceName}LoadingMode`] }).then(res => {
              if (res.code === 'RESP0000') {
                res.data = res.data ? res.data : []
                var arrd = this[`${spaceName}formatTreeData`](res.data.enclosure)
                if (node.data) {
                  arrd.forEach(o => {
                    o.projectName = node.data.projectName
                    o.children.forEach(d => {
                      d.projectName = node.data.projectName
                    })
                  })
                }
                this[`${spaceName}EnclosureList`] = arrd
                resolve(res.data.enclosure)
              }
            })
          } else if (node.data.spatialCode >= 300000000) {
            var findNode = []
            // resolve(this[`${spaceName}findNode`](this[`${spaceName}EnclosureList`], node.data.id).children)
            // if (this[`${spaceName}EnclosureList`].length !== 0) {
            //   findNode = this[`${spaceName}findNode`](this[`${spaceName}EnclosureList`], node.data.id).children
            // }
            if (!this[`${spaceName}EnclosureList`].userPermission && findNode.length > 0) {
              findNode = this[`${spaceName}findNode`](this[`${spaceName}EnclosureList`], node.data.id).children
              resolve(findNode)
              return false
            }
            if (this[`${spaceName}Level`] && node.data.level.toString() === this[`${spaceName}Level`]) {
              resolve([])
              return false
            }
            let url = `SpaceOrg/getNextEnclosureByEnclosureId?enclosureId=${node.data.id}`
            this.$https.axios({ method: 'get', url, loading: this[`${spaceName}LoadingMode`] }).then(res => {
              if (res.code === 'RESP0000') {
                if (this[`${spaceName}Ladder`] && res.data.level.toString() === '40') {
                  resolve([])
                  return false
                }
                res.data = res.data ? res.data : []
                var arrd = this[`${spaceName}formatTreeData`](res.data.enclosure)
                arrd.forEach(i => {
                  i.projectName = node.data.projectName
                  i.children.forEach(d => {
                    d.projectName = node.data.projectName
                  })
                })
                this[`${spaceName}EnclosureList`] = arrd
                resolve(res.data.enclosure)
              }
            })
          } else {
            resolve(this[`${spaceName}findNode`](this[`${spaceName}tree`], node.data.id).children)
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/mixins/allOrgTree.js